module.exports = __webpack_public_path__ + "static/neihu8-570eb41936d9f15f4ec735d17debfb0f.jpg";